<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      沙壆站<br>
站点介绍<br>
沙壆站位于东纵路与沙新路交汇处，车站沿东纵路东西向布置。西接东纵纪念馆站，东接燕子湖站。 沙壆站色彩基调以白色为主，棕色为辅，为地下站。车站为地下两层形式，地下一层为站厅层，地下二层为站台层，站台形式为岛式站台。车站共设有4个出入口，临近东纵小学、博明学校、龙翔学校、坪山税务局、沙壆社区、车站周边主要以住宅、学校为主。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:30	23:39	16号线	5分32秒	6分51秒<br>
田心	05:59	23:09	16号线	5分32秒	6分51秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:40	23:39	16号线	5分50秒	6分钟-9分钟<br>
田心	05:59	23:09	16号线	5分50秒	6分钟-9分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:40	00:39	16号线	5分50秒	6分钟-9分钟<br>
田心	05:59	00:09	16号线	5分50秒	6分钟-9分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
东纵路南侧（西）、南方医科大学深圳口腔医院、深圳市坪山区税务局办税服务厅、深圳市坪山区老干部活动中心、东北师范大学附属中学深圳学校<br><br>
B出入口:<br>
东纵路南侧（东）、深圳市坪山区东纵小学、新村小区、坪山区人民医院沙坣社区健康服务中心<br><br>
C出入口:<br>
东纵路北侧（东）、富润乐庭、龙翔学校、深圳市坪山区燕子湖国际会展中心<br><br>
D出入口:<br>
东纵路北侧（西）、博明学校、鼎盛工业园<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 坪山税务局<br>
818、939A、B762、M195、M279、M357、M546、M564、M576<br><br>
B出入口:<br>
公交站名： 沙坣新村<br>
818、939A、B762、E17、M195、M279、M357、M426、M546、M564、M576、高峰专线175号、B951<br><br>
D出入口:<br>
公交站名： 坪山税务局<br>
818、939B、B762、M195、M279、M357、M546、M564、M576<br><br>
D出入口:<br>
公交站名： 沙坣新村<br>
818、939B、B762、E17、M195、M279、M357、M426、M546、M564、M576、高峰专线175<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shiliuhaoxian",
            title: "16号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>